// extracted by mini-css-extract-plugin
export default {"collapse-typography":"mainStyle_collapse-typography__B48x2","custom-scrollbar":"mainStyle_custom-scrollbar__JRVts"};